import type { ReactNode } from 'react';

/**
 * BUILD-039 — one permission category (e.g. "Users & access", "Knowledge", "Vendors", "HR") as its own bordered card with a bold heading.
 * Shared by Roles & Permissions and the person "Edit permissions" drawer so both look the same. Rows are <tr> elements:
 * Permission | Allowed | status (column headings are kept for screen readers).
 */
export function PermissionGroupCard({ title, children }: { title: string; children: ReactNode }) {
  const id = `perm-group-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
  return (
    <section aria-labelledby={id} className="border border-gray-300 rounded-lg overflow-hidden bg-white shadow-sm" data-testid="permission-group">
      <h3 id={id} className="text-base font-bold text-navy bg-gray-50 border-b border-gray-300 px-4 py-2.5">{title}</h3>
      <table className="w-full text-sm table-fixed">
        <colgroup><col /><col className="w-20" /><col className="w-36" /></colgroup>
        <thead className="sr-only">
          <tr><th scope="col">Permission</th><th scope="col">Allowed</th><th scope="col">Status</th></tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </section>
  );
}

/** Row classes shared by both editors: a divider between rows (none above the first), padding inside the card. */
export const GROUP_ROW = 'border-t border-gray-100 first:border-t-0';
export const GROUP_LABEL_CELL = 'text-left font-normal py-2 pl-4 pr-3 align-top';
export const GROUP_ALLOWED_CELL = 'w-20 text-center align-top pt-2.5';
export const GROUP_STATUS_CELL = 'w-36 text-[11px] align-top pt-2.5 pr-3';
